// no-op on web!
export const PushNotificationsListener = () => {
  return null
}
